var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content bill-overseas-s-center-view" },
    [
      _c(
        "div",
        { staticClass: "main-content", attrs: { type: "primary" } },
        [
          _c("customs-file-search-condition", {
            ref: "queryBillActualAmountCondition",
            on: {
              advSearchItemResetCallBack: _vm.toQuery,
              add: _vm.addEventHandler,
              edit: _vm.editEventHandler,
              batchSave: _vm.batchSaveHandler,
              backList: _vm.backListEventHandler,
              gather: _vm.gatherEventHandler,
              print: _vm.printEventHandler,
              batchState: _vm.batchStateEventHandler,
              clearData: _vm.clearDataHandler,
              backState: _vm.backStateHandler,
              unFrozen: _vm.xhqCustomsUnFrozenHandler,
              openChatPage: _vm.xhqOpenChatPage
            }
          })
        ],
        1
      ),
      _c("customs-file-grid", {
        attrs: {
          "config-module": "20220113",
          "row-data": _vm.rowData,
          "grid-options": _vm.gridOptions
        },
        on: { batchSaveHandler: _vm.customsNoUpdateHandler }
      }),
      _c(
        "div",
        { staticClass: "pagination-wrapper" },
        [
          _vm.appendQuery
            ? _c(
                "div",
                { staticClass: "pagination-container" },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: { total: _vm.rowData.length, layout: "total" }
                  })
                ],
                1
              )
            : _c("cargo-pagination", {
                attrs: {
                  "config-module": "20220113",
                  total: _vm.total,
                  page: _vm.pageNum,
                  limit: _vm.pageSize
                },
                on: {
                  "update:page": function($event) {
                    _vm.pageNum = $event
                  },
                  "update:limit": function($event) {
                    _vm.pageSize = $event
                  },
                  pagination: function($event) {
                    return _vm.toQuery()
                  }
                }
              })
        ],
        1
      ),
      _c("customs-info-dialog", {
        ref: "customsInfoDialog",
        attrs: {
          visible: _vm.addDialog.visible,
          "selected-customs-info": _vm.selectedCustomsInfo,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.addDialog, "visible", $event)
          },
          successHandler: _vm.successHandler
        }
      }),
      _c("edit-customs-file", {
        ref: "fileDialog",
        attrs: {
          visible: _vm.editDialog.visible,
          "selected-file": _vm.selectedFile,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.editDialog, "visible", $event)
          },
          successHandler: _vm.successHandler
        }
      }),
      _c("back-list-window", {
        ref: "dcReturn",
        attrs: {
          "row-list": _vm.backList.rowList,
          visible: _vm.backList.visible
        },
        on: { visibleHandler: _vm.visibleHandler }
      }),
      _c("collect-info-window", {
        ref: "dcReturn",
        attrs: {
          "row-list": _vm.collectInfo.rowList,
          visible: _vm.collectInfo.visible
        },
        on: { visibleHandler: _vm.visibleHandler }
      }),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c("dc-send-out-window", {
        ref: "dcSendOut",
        attrs: {
          "send-out-dialog": _vm.sendOutDialog,
          visible: _vm.sendOutDialog.visible,
          job: _vm.job,
          "selected-files": _vm.selectedRows
        },
        on: {
          dcSendOutVisible: function($event) {
            _vm.sendOutDialog.visible = false
          },
          successHandler: _vm.successHandler
        }
      }),
      _c("batch-state-window", {
        attrs: {
          visible: _vm.batchStateWindow.visible,
          "label-name": _vm.batchStateWindow.labelName,
          title: _vm.batchStateWindow.title,
          files: _vm.batchStateWindow.files,
          "select-date": _vm.batchStateWindow.selectDate,
          "file-state": _vm.batchStateWindow.fileState
        },
        on: {
          closePage: _vm.visibleHandler,
          successHandler: _vm.batchStateSuccessHandler
        }
      }),
      _c("rollback-window", {
        attrs: {
          visible: _vm.rollbackWindow.visible,
          files: _vm.rollbackWindow.files
        },
        on: {
          closePage: _vm.visibleHandler,
          successHandler: _vm.batchStateSuccessHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }